import React from 'react';
import { AgentCustomerAnalysis } from '../../types/organizations';
import CustomerAnalysisItemCard from './CustomerAnalysisItemCard';

interface CustomerAnalysisModalProps {
  isOpen: boolean;
  analysis: AgentCustomerAnalysis | null;
  onClose: () => void;
}

const CustomerAnalysisModal: React.FC<CustomerAnalysisModalProps> = ({ isOpen, analysis, onClose }) => {
  if (!isOpen || !analysis) return null;

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };


  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
      <div className="relative top-20 mx-auto border w-11/12 md:w-3/4 lg:w-1/2 shadow-lg rounded-md bg-white">
        <div className="mt-0">
          {/* Close Button - Top Right */}
          <div className="flex justify-end mb-4 pt-2 pr-2">
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* Analysis Details */}
          <div className="space-y-2 px-4">
            <CustomerAnalysisItemCard analysis={analysis} index={0} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerAnalysisModal;
